import { render, staticRenderFns } from "./BoardReport.vue?vue&type=template&id=70c4cc6b&scoped=true&"
import script from "./BoardReport.vue?vue&type=script&lang=js&"
export * from "./BoardReport.vue?vue&type=script&lang=js&"
import style0 from "./BoardReport.vue?vue&type=style&index=0&id=70c4cc6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c4cc6b",
  null
  
)

/* custom blocks */
import block0 from "./BoardReport.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports